module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ピロスクリーンカメラモジュール-4K（32M）.7959d32a.png";